import React, { Fragment, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router";
import {
  faAsterisk,
  faPlus,
  faSave,
  faTimes } from
"@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import swal from "sweetalert";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import { Modal, ModalBody } from "reactstrap";
import Loader from "react-loader-spinner";
import "./GlobalGoal.css";

const goalFieldOptionArray = [
{ id: "course", field_name: "completed course requirement" },
{ id: "AND", field_name: "completed all of the following" },
{ id: "OR", field_name: "completed one of the following" }];

const asList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.objects)) return payload.objects;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

const getRelatedGoalId = (item) => item?.id ?? item?.goal?.id ?? null;
const getRelatedGoalName = (item) => {
  if (typeof item?.goal === "string") return item.goal;
  return item?.goal_name || item?.goal?.goal_name || "";
};

const createEmptyCriteria = (parentValue = false, parentCountArray = [], marginForParent = 0) => ({
  field_name: "",
  operator: "",
  value: "",
  course_req: "",
  green_simple_exp: "",
  parent: parentValue ? parentCountArray : [],
  level: parentValue ? parentCountArray.length : 0,
  margin: parentValue ? `${marginForParent}px` : "margin",
  have_not: ""
});


const AddNewModal = ({ isOpen, closeHandler, data }) => {
  const [input, setInput] = useState("");

  return (
    <Fragment>
      <Modal
        isOpen={isOpen}
        toggle={closeHandler}
        centered
        className="global-goal-modal">

        <ModalBody>
          <h5 className="global-goal-modal-title">{data.title}</h5>
          <div className="global-goal-modal-body">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              type="text"
              placeholder="Field Name"
              className="global-goal-input" />

          </div>
        </ModalBody>
        <div className="global-goal-modal-actions">
          <button
            disabled={!input}
            className={`global-goal-btn ${!input ? "disabled" : "primary"}`}
            onClick={() => data.save(input)}
            type="button">

            <FontAwesomeIcon icon={faSave} />
            Save
          </button>
          <button
            className="global-goal-btn ghost"
            onClick={closeHandler}
            type="button">

            <FontAwesomeIcon icon={faTimes} />
            Cancel
          </button>
        </div>
      </Modal>
    </Fragment>);

};

const GlobalGoal = () => {
  let history = useHistory();

  const [parentCount, setParentCount] = useState(0);
  const [parentCountArray, setParentCountArray] = useState([]);
  const [courseCriteria, setCourseCriteria] = useState([createEmptyCriteria()]);
  const [goalFieldOption, setGoalFieldOption] = useState(goalFieldOptionArray);

  const [goalName, setGoalName] = useState();
  const [goalDescription, setGoalDescription] = useState();
  // const [goalId, setGoalId] = useState(location?.pathname?.split("/").pop());
  const [goalData] = useState();
  const [addNewCourseModal, setAddNewCourseModal] = useState(false);
  const [addNewGoalModal, setAddNewGoalModal] = useState(false);
  const [marginForParent, setMarginForParent] = useState("");
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [requiredSubGoalData, setRequiredSubGoalData] = useState([]);
  const [selectedGoal, setSelectedGoal] = useState([]);
  const [goalpublishData, setGoalPublishData] = useState([]);
  const [courseListData, setCourseListData] = useState([]);
  const [fieldOperators, setFieldOperators] = useState([]);
  const [, setAddGoalName] = useState();
  const [criteriaError, setCriteriaError] = useState("");
  const [saving, setSaving] = useState(false);

  const gpaRef = useRef();
  const fieldOptionRef = useRef();
  const courseRef = useRef();
  const arithemeticOperatorRef = useRef();
  const timeout = useRef();
  const addGoalNameRef = useRef();

  // const getGoalDetail = () => {
  //   GetStudentService.getGoalDetail(goalId)
  //     .then((data) => {
  //       setGoalData(data?.data);
  //       if(data?.data?.green){
  //       setCourseCriteria(Object.values(data?.data?.green));
  //       }
  //       setGoalName(data?.data?.goal_name);
  //       setGoalDescription(data?.data?.goal_description);
  //     })
  //     .catch((error) => {
  //     });
  // };

  const isCriteriaComplete = (item) => {
    if (!item?.have_not || !item?.field_name) return false;
    if (item.field_name === "AND" || item.field_name === "OR") return true;
    if (item.field_name === "course") return !!item.course_req;
    return item.operator !== "" && item.operator != null && String(item.value ?? "").trim() !== "";
  };

  const saveGoalMap = () => {
    if (saving) return;
    const hasValidCriteria = (courseCriteria || []).some(isCriteriaComplete);
    if (!hasValidCriteria) {
      setCriteriaError("Criteria is required. Select a criteria option.");
      swal({
        text: "Empty criteria for selection. Please choose a criteria option.",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true
        },
        closeOnClickOutside: false
      });
      return;
    }
    setCriteriaError("");
    let obj = {
      goal_description: goalDescription,
      goal_id: undefined,
      goal_name: goalName,
      green: [null, ...courseCriteria],
      // school_id: user?.school_id,
      subgoal_id: requiredSubGoalData
    };
    setSaving(true);
    GetStudentService.createGoalMap(obj)
    .then((data) => {
      if (data?.msg) {
        swal({
          text: `Selected Literal goalfield ${data["msg"]}`,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true
          },
          closeOnClickOutside: false
        });
      } else {
        swal({
          text: `Global Goal Initialize Successfully!`,
          icon: "success",
          buttons: {
            OK: true
          },
          closeOnClickOutside: false
        }).then((value) => {
          if (value === "OK") {
            history.push('/school_it/ccplus');
          }
        });
      }
    })
    .catch((error) => {
      swal({
        text: error?.response?.data ?
        "The given Goal name already exists" :
        "Unable to save goal. Please try again.",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true
        },
        closeOnClickOutside: false
      });
    })
    .finally(() => {
      setSaving(false);
    });
  };

  const saveNewCourse = (name) => {
    let obj = {
      name: name,
      school_id: user?.school_id
    };
    GetStudentService.saveNewCourse(obj)
    .then((_data) => {
      setAddNewCourseModal(false);
    })
    .catch((error) => {
      if (error.response.data) {
        swal({
          text: error.response.data.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true
          },
          closeOnClickOutside: false
        });
      }
    });
  };
  const saveNewGoalField = (name) => {
    let obj = {
      field_name: name,
      school_id: user?.school_id
    };
    GetStudentService.saveNewGoalField(obj)
    .then((_data) => {
      setAddNewGoalModal(false);
    })
    .catch((error) => {
      if (error.response.data) {
        swal({
          text: error.response.data.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true
          },
          closeOnClickOutside: false
        });
      }
    });
  };

  useEffect(() => {
    if (selectedGoal?.length > 0) {
      let array = [];
      selectedGoal.map((item) => {
        let obj = {};
        obj["sub_goal"] = getRelatedGoalId(item);
        obj["goal_name"] = getRelatedGoalName(item);
        obj["sub_goal_id"] = item?.subgoal_id || item?.goal?.subgoal_id || "";
        array.push(obj);
      });
      setRequiredSubGoalData(array);
    } else {
      setRequiredSubGoalData([]);
    }
  }, [selectedGoal]);

  useEffect(() => {
    setParentCountArray([...parentCountArray, parentCount + 1]);
  }, [parentCount]);

  useEffect(() => {
    setMarginForParent(40 * parentCountArray.length);
  }, [JSON.stringify(parentCountArray)]);

  const AddNewCriteria = (parentValue) => {
    if (parentValue) {
      setParentCount(parentCount + 1);
    }
    setCourseCriteria([
      ...courseCriteria,
      createEmptyCriteria(parentValue, parentCountArray, marginForParent)
    ]);
  };

  const removeCourseCriteria = (index) => {
    if ((courseCriteria || []).length <= 1) return;
    const next = courseCriteria.filter((_, i) => i !== index);
    setCourseCriteria(next.length ? next : [createEmptyCriteria()]);
  };

  const getCourseList = () => {
    GetStudentService.listOfCourse(user?.school_id)
    .then((data) => {
      setCourseListData(asList(data?.data));
    })
    .catch((_error) => {
      setCourseListData([]);
    });
  };

  const getFieldOperators = () => {
    GetStudentService.listOfOperators()
    .then((data) => {
      setFieldOperators(asList(data?.data));
    })
    .catch((_error) => {
      setFieldOperators([]);
    });
  };

  const getGoalField = () => {
    GetStudentService.goalFieldForCreateGoal(user?.school_id)
    .then((data) => {
      const apiFields = asList(data?.data);
      const seen = new Set(goalFieldOptionArray.map((opt) => String(opt.id)));
      const extras = apiFields.filter((field) => field && !seen.has(String(field.id)));
      setGoalFieldOption([...extras, ...goalFieldOptionArray]);
    })
    .catch((_error) => {
      setGoalFieldOption(goalFieldOptionArray);
    });
  };

  const handleGoalNameChange = (e) => {
    const value = e?.target?.value ?? addGoalNameRef.current?.value ?? "";
    setAddGoalName(value);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      getPublishData(value);
    }, 300);
  };

  const getPublishData = (goalName = "") => {
    GetStudentService.getGoalPublisher(user?.school_id, goalName)
    .then((data) => {
      const list = asList(data?.data);
      setGoalPublishData(list);
    })
    .catch((_error) => {
      setGoalPublishData([]);
    });
  };

  const handlehaveOrHaveNotChange = (index, e) => {
    courseCriteria[index].have_not = e.target.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleFieldOption = (index, e) => {
    courseCriteria[index].field_name = e.target.value;
    setCourseCriteria([...courseCriteria]);
    if (e.target.value) setCriteriaError("");
  };

  const handleCourseChange = (index) => {
    courseCriteria[index].course_req = courseRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleArithemeticOperatorChange = (index) => {
    courseCriteria[index].operator = arithemeticOperatorRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleGPAChange = (index) => {
    courseCriteria[index].value = gpaRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleSelectedGoal = (item) => {
    const alreadyAdded = selectedGoal.some(
      (selected) => String(getRelatedGoalId(selected)) === String(getRelatedGoalId(item))
    );
    if (!alreadyAdded) {
      setSelectedGoal([...selectedGoal, item]);
    }
    setGoalPublishData([]);
    if (addGoalNameRef.current) {
      addGoalNameRef.current.value = "";
    }
    setAddGoalName("");
  };

  const removeSelectedGoal = (index) => {
    selectedGoal.splice(index, 1);
    setSelectedGoal([...selectedGoal]);
  };

  useEffect(() => {
    getCourseList();
    getFieldOperators();
    getGoalField();
    return () => clearTimeout(timeout.current);
  }, []);

  const relatedGoalOptions = (goalpublishData || []).filter(
    (item) =>
      !selectedGoal.some(
        (selected) =>
          String(getRelatedGoalId(selected)) === String(getRelatedGoalId(item))
      )
  );

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="global-goal-page">
            <div className="global-goal-header">
              <div>
                <h1 className="global-goal-title">Add Global Goal</h1>
                <p className="global-goal-subtitle">
                  Define a global goal and green requirement criteria
                </p>
              </div>
            </div>

            <div className="global-goal-card">
              <div className="global-goal-field">
                <label className="global-goal-label">
                  Goal Name <span className="global-goal-required">*</span>
                </label>
                <div className="global-goal-input-wrap">
                  <input
                    value={goalName}
                    onChange={(e) => setGoalName(e.target.value)}
                    type="text"
                    placeholder="Type a goal name"
                    className="global-goal-input" />

                  <FontAwesomeIcon
                    className="global-goal-asterisk"
                    icon={faAsterisk}
                    color="red" />

                </div>
              </div>

              <div className="global-goal-field">
                <label className="global-goal-label">
                  Goal Description <span className="global-goal-required">*</span>
                </label>
                <div className="global-goal-input-wrap">
                  <textarea
                    value={goalDescription}
                    onChange={(e) => setGoalDescription(e.target.value)}
                    className="global-goal-textarea"
                    placeholder="Type a goal description"
                    rows="5" />

                  <FontAwesomeIcon
                    className="global-goal-asterisk"
                    icon={faAsterisk}
                    color="red" />

                </div>
              </div>

              <div className="global-goal-field">
                <label className="global-goal-label">
                  Add Related Goal
                  <span className="global-goal-optional"> (optional)</span>
                </label>
                <input
                  ref={addGoalNameRef}
                  onChange={handleGoalNameChange}
                  onFocus={() => getPublishData(addGoalNameRef.current?.value || "")}
                  type="text"
                  className="global-goal-input"
                  placeholder="Type a goal name to add"
                  autoComplete="off" />

                {relatedGoalOptions.length > 0 &&
                <ul className="global-goal-dropdown">
                    {relatedGoalOptions.map((item, index) =>
                  <li
                    key={getRelatedGoalId(item) || index}
                    onClick={() => handleSelectedGoal(item)}>

                        {getRelatedGoalName(item)}
                      </li>
                  )}
                  </ul>}

                {selectedGoal?.length > 0 &&
                <div className="global-goal-chips">
                    {selectedGoal?.map((item, index) =>
                  <div
                    key={getRelatedGoalId(item) || index}
                    className="global-goal-chip">

                        {getRelatedGoalName(item)}
                        <FontAwesomeIcon
                      onClick={() => removeSelectedGoal(index)}
                      icon={faTimes}
                      className="global-goal-chip-remove" />

                      </div>
                  )}
                  </div>}

              </div>

              <div className="global-goal-criteria">
                <div className="global-goal-criteria-header">
                  Create a set of criteria for green
                  <span className="global-goal-required"> *</span>
                </div>
                <div className="global-goal-criteria-body">
                  {courseCriteria?.length > 0 &&
                  courseCriteria?.map((item, index) =>
                  <div key={index} className="global-goal-criteria-block">
                        <div
                      className="global-goal-criteria-row"
                      style={{
                        marginLeft: item.level > 0 ? "48px" : "0"
                      }}>

                          <button
                        type="button"
                        disabled={goalData?.is_global || courseCriteria.length <= 1}
                        onClick={() => removeCourseCriteria(index)}
                        className="global-goal-remove-btn"
                        style={{
                          opacity: goalData?.is_global || courseCriteria.length <= 1 ? "0.65" : "1"
                        }}>

                            <FontAwesomeIcon icon={faTimes} />
                          </button>
                          <p className="global-goal-criteria-label">
                            Student must
                          </p>
                          <select
                        value={item?.have_not || ""}
                        disabled={goalData?.is_global}
                        onChange={(e) => handlehaveOrHaveNotChange(index, e)}
                        className="global-goal-select"
                        required>

                            <option value="" disabled>
                              Select Option
                            </option>
                            <option value="True">have</option>
                            <option value="False">have not </option>
                          </select>
                          <select
                        ref={fieldOptionRef}
                        value={item?.field_name || ""}
                        onChange={(e) => handleFieldOption(index, e)}
                        disabled={goalData?.is_global}
                        className={`global-goal-select${criteriaError && !item?.field_name ? " is-invalid" : ""}`}
                        style={{ width: "220px" }}
                        required
                        aria-required="true">

                            <option disabled value="">
                              Select
                            </option>
                            {(goalFieldOption?.length ? goalFieldOption : goalFieldOptionArray).map((opt, optIndex) =>
                        <option key={opt?.id || optIndex} value={opt?.id}>
                                {opt?.field_name || opt?.name}
                              </option>
                        )}
                          </select>
                          {!(
                      item.field_name === "AND" ||
                      item.field_name === "OR" ||
                      item.field_name === "course" ||
                      item.field_name === "") &&

                      <div className="global-goal-inline-group">
                              <select
                          value={item?.operator || ""}
                          disabled={goalData?.is_global}
                          ref={arithemeticOperatorRef}
                          onChange={() =>
                          handleArithemeticOperatorChange(index)}

                          className="global-goal-select">

                                <option disabled value="">
                                  Select Operator
                                </option>
                                {fieldOperators?.map((op, opIndex) =>
                          <option
                            key={op?.id || opIndex}
                            value={parseInt(op?.id)}>

                                    {op?.operator}
                                  </option>
                          )}
                              </select>
                              <input
                          type="text"
                          ref={gpaRef}
                          value={item?.value}
                          disabled={goalData?.is_global}
                          onChange={() => handleGPAChange(index)}
                          className="global-goal-value-input" />

                            </div>}

                          {item.field_name === "course" &&
                      <select
                        ref={courseRef}
                        value={item?.course_req}
                        disabled={goalData?.is_global}
                        onChange={() => handleCourseChange(index)}
                        className="global-goal-select">

                              <option>Select Course</option>
                              {courseListData?.map((courseItem, courseIndex) =>
                        <option
                          key={courseItem?.course?.id || courseIndex}
                          value={courseItem?.course?.id}>

                                  {courseItem?.course?.name}
                                </option>
                        )}
                            </select>}

                        </div>
                        {(item.field_name === "AND" ||
                    item.field_name === "OR") &&
                    <div className="global-goal-subcriteria">
                            <button
                        type="button"
                        className="global-goal-add-sub"
                        onClick={() => AddNewCriteria(true)}>

                              <FontAwesomeIcon icon={faPlus} />
                            </button>
                            <p>
                              <b>Add additional sub-criteria</b>
                            </p>
                          </div>}

                      </div>
                  )}

                  {criteriaError &&
                  <p className="global-goal-criteria-error">{criteriaError}</p>}

                  <div className="global-goal-add-criteria">
                    <button
                      type="button"
                      disabled={goalData?.is_global}
                      className={`global-goal-btn secondary ${
                      goalData?.is_global ? "disabled" : ""
                      }`}
                      onClick={() => AddNewCriteria(false)}>

                      <FontAwesomeIcon icon={faPlus} />
                      Add additional Criteria
                    </button>
                  </div>
                </div>
              </div>

              <div className="global-goal-actions">
                <button
                  type="button"
                  disabled={saving || !(goalName && goalDescription)}
                  className={`global-goal-btn ${
                  goalName && goalDescription ? "primary" : "disabled"
                  }`}
                  onClick={saveGoalMap}>

                  {saving ?
                <Loader type="TailSpin" color="#fff" height={16} width={16} /> :

                <FontAwesomeIcon icon={faSave} />}

                  {saving ? "Saving..." : "Save"}
                </button>
                <button
                  type="button"
                  className="global-goal-btn ghost"
                  disabled={saving}
                  onClick={() => history.push("/school_it/ccplus")}>

                  <FontAwesomeIcon icon={faTimes} />
                  Cancel
                </button>
              </div>
            </div>

            {addNewCourseModal &&
            <AddNewModal
              isOpen={addNewCourseModal}
              closeHandler={() => {
                setAddNewCourseModal(false);
              }}
              data={{
                title: "Create Required Course Set",
                save: saveNewCourse
              }} />}



            {addNewGoalModal &&
            <AddNewModal
              isOpen={addNewGoalModal}
              closeHandler={() => {
                setAddNewGoalModal(false);
              }}
              data={{ title: "New Goal Field", save: saveNewGoalField }} />}


          </div>
        </div>
      </div>
    </Fragment>);

};

export default GlobalGoal;